import { render, staticRenderFns } from "./HoldProposals.vue?vue&type=template&id=ef64bc2a&"
import script from "./HoldProposals.vue?vue&type=script&lang=js&"
export * from "./HoldProposals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports